<router-outlet></router-outlet>
<button
  (click)="sendEmail()"
  *ngIf="user?.role !== 'ROLE_SUPER_ADMIN' && !isPublicRoute"
  class="mail-icon flex justify-center items-center gap-2"
  matTooltip="En cas de problème, veuillez contacter l'administrateur"
>
  <mat-icon class="icon"> email </mat-icon>
  <p class="text">Support</p>
</button>
